import { CSSProperties } from 'react'

export type OilResourceType = {
  name: string
  unit: string
  // icon 등 전달하고자 하는 데이터가 있을 시 추가
  style?: CSSProperties
}

export const oilResourceMap: { [koiCd: string]: OilResourceType } = {
  D: {
    name: '경유',
    unit: 'ℓ',
    style: { background: '#399758' },
  },
  L: {
    name: 'LPG',
    unit: 'ℓ',
    style: { background: '#D73A09' },
  },
  H: {
    name: '수소',
    unit: '㎏',
    style: { background: '#1a5c99' },
  },

  C: {
    name: 'CNG',
    unit: '㎥',
    style: { background: '#A36802' },
  },
}

export type OilType = keyof typeof oilResourceMap
